// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  guildMemberId: __t.u64().primaryKey().name("guild_member_id"),
  guildId: __t.u64().name("guild_id"),
  identity: __t.identity(),
  title: __t.string(),
  joinedAt: __t.timestamp().name("joined_at"),
});
